// Copyright (c) 2005 David Caldwell,  All Rights Reserved.

var lib = require('./lib'), filter=lib.filter, map=lib.map;
var plat = require('./platform');
var dom = require('./dom'), timeout=dom.timeout, px=dom.px, doc=dom.doc;
var prnt = require('./print'), printf=prnt.printf;

function getElementsByClassName(name, node)
{
    if (!node) node = document;
    if (document.getElementsByClassName)
        return node.getElementsByClassName(name);

    // IE:
    return filter(function(n) { return n.className && n.className.match("\\b"+name+"( |$)") },
                  node.getElementsByTagName('*'));
}

function containsChild(haystack_el, needle_el, guard_el) {
    let max_depth=100;
    while (max_depth--) {
        if (needle_el == haystack_el)
            return true;
        if (needle_el == guard_el || needle_el == undefined)
            return false;
        needle_el = needle_el.parentNode;
    }
    throw("containsChild overran!");
}

class Menus {
    // menu_close_hook = []; FIXME: our babel is too old for this??
    constructor() {
        this.menu_close_hook = [];
    }

    configure(menubar_el, hamburger_el) {
        let saved = [];
        this.top = getElementsByClassName("menu", menubar_el);
        hamburger_el.onclick = (e) => {
            if (!hamburger_el.classList.toggle("selected"))
                for (let t of this.top)
                    this.close_menu(t);
        };

        for (let t of this.top) {
            t.onclick = (e) => this.open_menu(e, t);
            for (let i of getElementsByClassName("menu-item", t))
                if (i.firstChild.tagName != "A") // Don't do this for Messages, Contact us links because we can't synthesize "command-click" to open a new tab
                    i.onclick = (e) => { if (e.target != i.firstChild) { doc.click(i.firstChild); new plat.event(e).stop(); } };
        }
    }

    open_menu(e, menu) {
        let event = new plat.event(e);
        var sub = getElementsByClassName("menubody", menu);
        if (sub.length == 0)
            return;
        if (sub.length != 1)
            printf("Can't have more than one menubody in a menu!!\n");
        sub=sub[0];

        if (containsChild(sub, e.target, menu)) // ignore clicks bubbling up from <input>s in the .menubody
            return;

        if (menu.classList.toggle("selected")) {
            for (let t of this.top)
                if (t != menu)
                    this.close_menu(t);
        } else if (this.menu_close_hook[menu])
            this.menu_close_hook[menu]();

        for (let b of getElementsByClassName("menu-back", sub))
            b.onclick = () => this.close_menu(menu);
    }

    close_menu(menu) {
        if (!menu.classList.contains("selected"))
            return; // nothing to close, but more importantly, don't notify.
        menu.classList.remove("selected");
        if (this.menu_close_hook[menu])
            this.menu_close_hook[menu]();
    }

    add_close_hook(menu_el, hook_fn) {
        let previous = this.menu_close_hook[menu_el];
        this.menu_close_hook[menu_el] = () => {
            if (previous) previous();
            hook_fn()
        };
    }
}
let menus = new Menus();
require('./dom').on_load(() => menus.configure(doc.id("menubar"), doc.id("hamburger")));

module.exports = {
    menu_close_hook: (menu_el, hook_fn) => menus.add_close_hook(menu_el, hook_fn)
};
// Copyright (c) 2005 David Caldwell,  All Rights Reserved.

var lib = require('./lib'), filter=lib.filter, map=lib.map;
var plat = require('./platform');
var dom = require('./dom'), timeout=dom.timeout, px=dom.px, doc=dom.doc;
var prnt = require('./print'), printf=prnt.printf;

function getElementsByClassName(name, node)
{
    if (!node) node = document;
    if (document.getElementsByClassName)
        return node.getElementsByClassName(name);

    // IE:
    return filter(function(n) { return n.className && n.className.match("\\b"+name+"( |$)") },
                  node.getElementsByTagName('*'));
}

function containsChild(haystack_el, needle_el, guard_el) {
    let max_depth=100;
    while (max_depth--) {
        if (needle_el == haystack_el)
            return true;
        if (needle_el == guard_el || needle_el == undefined)
            return false;
        needle_el = needle_el.parentNode;
    }
    throw("containsChild overran!");
}

class Menus {
    // menu_close_hook = []; FIXME: our babel is too old for this??
    constructor() {
        this.menu_close_hook = [];
    }

    configure(menubar_el, hamburger_el) {
        let saved = [];
        this.top = getElementsByClassName("menu", menubar_el);
        hamburger_el.onclick = (e) => {
            if (!hamburger_el.classList.toggle("selected"))
                for (let t of this.top)
                    this.close_menu(t);
        };

        for (let t of this.top) {
            t.onclick = (e) => this.open_menu(e, t);
            for (let i of getElementsByClassName("menu-item", t))
                if (i.firstChild.tagName != "A") // Don't do this for Messages, Contact us links because we can't synthesize "command-click" to open a new tab
                    i.onclick = (e) => { if (e.target != i.firstChild) { doc.click(i.firstChild); new plat.event(e).stop(); } };
        }
    }

    open_menu(e, menu) {
        let event = new plat.event(e);
        var sub = getElementsByClassName("menubody", menu);
        if (sub.length == 0)
            return;
        if (sub.length != 1)
            printf("Can't have more than one menubody in a menu!!\n");
        sub=sub[0];

        if (containsChild(sub, e.target, menu)) // ignore clicks bubbling up from <input>s in the .menubody
            return;

        if (menu.classList.toggle("selected")) {
            for (let t of this.top)
                if (t != menu)
                    this.close_menu(t);
        } else if (this.menu_close_hook[menu])
            this.menu_close_hook[menu]();

        for (let b of getElementsByClassName("menu-back", sub))
            b.onclick = () => this.close_menu(menu);
    }

    close_menu(menu) {
        if (!menu.classList.contains("selected"))
            return; // nothing to close, but more importantly, don't notify.
        menu.classList.remove("selected");
        if (this.menu_close_hook[menu])
            this.menu_close_hook[menu]();
    }

    add_close_hook(menu_el, hook_fn) {
        let previous = this.menu_close_hook[menu_el];
        this.menu_close_hook[menu_el] = () => {
            if (previous) previous();
            hook_fn()
        };
    }
}
let menus = new Menus();
require('./dom').on_load(() => menus.configure(doc.id("menubar"), doc.id("hamburger")));

module.exports = {
    menu_close_hook: (menu_el, hook_fn) => menus.add_close_hook(menu_el, hook_fn)
};
